import {makeStyles} from "tss-react/mui";
import {Box, TextField, TextFieldProps} from "@mui/material";
import {AdminFieldContainer, IProps as AdminFieldContainerProps} from "@/pages/ManagerView/ContentCreation/AdminFieldContainer";

export type IProps = Omit<AdminFieldContainerProps, "children"> & Omit<TextFieldProps, "className" | "error" | "variant"> & {
	className?: string,
	error?: string
};


const useStyles = makeStyles()((_theme) => ({
	adminInputText: {

	},
	textField: {
		width: "100%"
	}
}));

export const AdminInputText = ({children, required, error, outline, className, ...textFieldProps}: IProps): JSX.Element => {
	const {cx, classes} = useStyles();
	return (
		<Box className={cx(classes.adminInputText, className)}>
			<AdminFieldContainer error={error} required={required} outline={outline}>
				<TextField error={!!error} required={required} className={classes.textField} variant="outlined" InputLabelProps={{shrink: true}} {...textFieldProps}/>
			</AdminFieldContainer>
			{children}
		</Box>

	);
}